var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"badge-list"},[_vm._l((_vm.$slots),function(index,name){return _vm._t(name)})],2)}
var staticRenderFns = []

export { render, staticRenderFns }